import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import Rating from '~/components/Rating'

const RatingCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  if (value !== undefined) {
    return (
      <div className="rating-cell-renderer-component">
        <Rating color="#626262" maxValue={5} size={14} value={value} />
      </div>
    )
  }

  return <div />
}

export default RatingCellRenderer
